[
	"basic",
	"constant",
	"invscaling",
	"pegasos"
]
